"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const Button_1 = require("../Button/Button");
const RefreshButton = (0, styled_components_1.default)(Button_1.Button) `
  border-radius: 5px;
  border: 2px solid ${colors_1.blue};
  color: ${colors_1.acBlueDark};
  background-color: ${colors_1.white};
  font-size: 1.4rem;
  padding: 0 1rem;
  height: 2.4rem;

  @media ${media_1.media.smallDesktop} {
    border-radius: 10px;
    height: 4.2rem;
  }

  @media ${media_1.media.largeDesktop} {
    padding: 0 5rem;
  }
`;
exports.RefreshButton = RefreshButton;
